import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPracticeViewsConfigRoute: InvariantJiraRoute = {
	name: 'servicedesk-practice-views-config',
	path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit/:boardId',
	query: ['config'],
	exact: true,
};
